import React from 'react';
import ReactDOM from 'react-dom';

export default function Portal({ children, wrapper = 'custom-portal-wrapper' }) {
  const [portal, setPortal] = React.useState(null);

  React.useLayoutEffect(() => {
    let element = document.getElementById(wrapper);
    if (!element) {
      element = document.createElement('div');
      element.setAttribute('id', wrapper);
      document.body.appendChild(element);
    }
    setPortal(element);
  }, [portal, wrapper]);

  if (!portal) return null;

  return ReactDOM.createPortal(children, portal);
}
